/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import {Toaster} from "@blueprintjs/core/lib/esm/index";
import {WrcDate} from "./WrcDate";

export class WrcGlobal {

    /**
     * constants used by select/other controls
     * @type {string}
     */

    // Internal value for 'Other' selections
    static OTHERDEFAULT = 'Other';

    // This is the value the DB wants to see for 'Other' selections
    // TODO: this is a WIP - as of now this has to be the same as OTHERDEFAULT
    static DB_OTHERDEFAULT = 'Other';

    // Append this to a field name to get the 'Other' selection field
    static OTHEREXT = '_specify_other';

    // Append this to a field name to get the 'Unknown' selection field
    static UNKNOWNEXT = '_unknown';

    // Append this to a field name to get the 'not reported' selection field
    static NOREPORTEXT = '_not_reported';

    // The label type used by form builder
    static FORMLABEL = '*LABEL*';

    // Use a variable named ['varname' + '_min'/'_max'] to find the min/max for the field
    static USEVARIABLE = '*';

    /**
     * the DB likes to use these as true/false
     * @type {{FALSE: string, TRUE: string, YES: string, NO: string}}
     */
    static dbBool = { FALSE: '0', TRUE: '1', YES: 'Yes', NO: 'No', UNKNOWN: 'Unknown', UNANSWERED: '' };

    /**
     * enums for dialog box states
     * @type {{DIALOG_CLOSED: number, DIALOG_EDIT: number, DIALOG_NEW: number}}
     */
    static dialogModes = { DIALOG_CLOSED: 0, DIALOG_EDIT: 1, DIALOG_NEW: 2 };

    /**
     * object containing all of the potential cancer locations
     * @type {{Bladder: string, Bone: string, etc...}}
     */
    static cancerLocationList = {
        'Bladder': "Bladder",
        'Bone': "Bone",
        'Brain': "Brain",
        'Breast': "Breast",
        'Cervix': "Cervix",
        'Colon': "Colon",
        'Endometrium': "Endometrium",
        'Esophagus': "Esophagus",
        'Gallbladder': "Gallbladder",
        'Head &amp; neck (mouth, nose, and throat)': "Head & neck (mouth, nose, and throat)",
        'Kidney': "Kidney",
        'Leukemia': "Leukemia",
        'Liver': "Liver",
        'Lung': "Lung",
        'Lymphoma, including Hodgkins': "Lymphoma, including Hodgkins",
        'Mesothelioma': "Mesothelioma",
        'Multiple myeloma': "Multiple myeloma",
        'Ovary': "Ovary",
        'Pancreas': "Pancreas",
        'Prostate': "Prostate",
        'Rectum': "Rectum",
        'Skin (melanoma, no basal or squamous)': "Skin (melanoma, no basal or squamous)",
        'Stomach': "Stomach",
        'Testis': "Testis",
        'Thyroid': "Thyroid",
        'Uterus': "Uterus",
        'Vagina': "Vagina",
        [WrcGlobal.OTHERDEFAULT]: "Other",
        'Refused': "Refused",
        'Unknown': "Unknown",
        // 'None': "None",

    };

    /**
     * return a simple class to display toasts
     * @type {IToaster}
     */
    static toasts = Toaster.create();

    /**
     * function to log me out
     */
    static logout = () => window.location.reload(true);

    /**
     * evaluates a DB field to determine TRUE or FALSE
     * @param theval
     * @returns {boolean}
     */
    static isTrue = (theval) => (theval === 'Yes') || (theval === WrcGlobal.dbBool.TRUE);

    /**
     * get today's date as a formatted string
     * @returns {string}
     */
    static get_db_today() {
        const today = new WrcDate();
        return today.getDatabaseDate();
    }

    /**
     * add days to an existing date
     * @param WrcDate
     * @param days
     * @returns {Date}
     */
    static addDays(wdate, days) {  // eslint-disable-line
        let jsdate = new Date(wdate.getJsDate().toString());
        jsdate.setDate(jsdate.getDate() + days);
        return jsdate;
    }

    /**
     * add hours to an existing date
     * @param WrcDate
     * @param hours
     * @returns {Date}
     */
    static addHours(wdate, hours) {  // eslint-disable-line
        let jsdate = new Date(wdate.getJsDate().toString());
        jsdate.setHours(jsdate.getHours() + hours);
        return jsdate;
    }

    /**
     * calculate min/max dates
     * @param appthis
     * @param hours
     */
    static calcMinMaxDates(wdate, hours){
        let hmin = 0,
            hmax = 0;

        if (hours) {
            if (hours === WrcGlobal.OTHERDEFAULT) {
                //nothin
            } else if (hours.split) {
                let harr = hours.split('-');
                if (harr.length === 2) {
                    hmin = parseInt(harr[0], 10);
                    hmax = parseInt(harr[1], 10);
                } else {
                    hmin = hmax = parseInt(harr[0], 10);
                }
            } else {
                hmin = hmax = hours;
            }
            if (hmax % 24 > 0) {
                hmax += 24;
            }
        }
        return({
            date_min: WrcGlobal.addHours(wdate, hmin),
            date_max: WrcGlobal.addHours(wdate, hmax)
        });
    }

    /**
     * send an email to the supplied address
     * @param e
     * @param emailto
     */
    static sendEmail(e, emailto, emailsubj) {
        window.open('mailto:' + emailto + '?subject=' + emailsubj);
    }
}
